
export const itemdetails = {
    "name": "Aurora",
    "collection": "Amoled",
    "image": "https://media.giphy.com/media/IiuZjA4RQUKIf5TbMi/giphy-downsized-large.gif",
    "price": "0.0212 ETH",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    "creator": "Stacy McElroy",
    "creator_image": "https://i.imgur.com/ZqZQZqg.jpg",
    "collection_image": "https://i.imgur.com/ZqZQZqg.jpg",
    "owner": "Stacy McElroy",
    "owner_image": "https://i.imgur.com/ZqZQZqg.jpg",
}